import { render, staticRenderFns } from "./SRH002M01.vue?vue&type=template&id=736bed42&"
import script from "./SRH002M01.vue?vue&type=script&lang=js&"
export * from "./SRH002M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports